<template>
  <v-card>
    <vue-perfect-scrollbar>
      <v-card-text class="customer-movements pa-0">
        <v-layout justify-center align-center class="hovereable w-100 py-4" @click="dialogSchedule = true">
          <v-flex md12 text-xs-center>
            Agregar gestión <v-icon class="pl-1" small>fas fa-plus</v-icon>
          </v-flex>
        </v-layout>
        <v-container grid-list-lg fluid>
          <v-layout row wrap>
            <table-skeleton :columns="2" :is-customer-movements="true" :has-btn="true" v-if="isSearching">
            </table-skeleton>
            <v-data-table
              v-else
              :headers="headers"
              hide-actions
              class="w-100"
              no-data-text="No se encontraron datos"
              :items="data.data"
              :pagination.sync="sorting">
              <template slot="items" slot-scope="props">
                <tr>
                  <td>
                    <v-layout row wrap>
                      <v-flex shrink>
                        <v-avatar
                          size="30px"
                          color="k-orange-linear">
                          <v-icon small class="white--text">
                          {{ getChannelField('id', props.item.channel_id, 'icon') }}
                          </v-icon>
                        </v-avatar>
                      </v-flex>
                      <v-flex>
                        <h4>
                          {{ props.item.local_schedule_date | formatDate }}
                        </h4>
                        <small class="small">{{ getChannelField('id', props.item.channel_id, 'name') }}</small>
                      </v-flex>
                    </v-layout>
                  </td>
                  <td>{{ props.item.to }}</td>
                  <td>
                    {{ props.item.status }}
                  </td>
                  <td class="text-xs-center">
                    <v-btn flat icon @click="expandRow(props)">
                      <v-icon small>fa-chevron-down</v-icon>
                    </v-btn>
                  </td>
                </tr>
              </template>
              <template slot="expand" slot-scope="props" colspan="4">
                <v-layout row wrap>
                  <v-flex xs12>
                    <notification-info :i="props.index" :item="props.item">
                    </notification-info>
                  </v-flex>
                </v-layout>
              </template>
            </v-data-table>
            <paginator :meta="data.meta" :limit="limit" @changePage="page = $event" v-if="Object.keys(data).length">
            </paginator>
          </v-layout>
        </v-container>
      </v-card-text>
    </vue-perfect-scrollbar>
    <save-dialog
      :title="title"
      :dialog="dialogSchedule"
      :form="formSchedule"
      :route="route"
      :edit="false"
      :hasMore="false"
      :more="false"
      @closeModal="closeModal">
      <template slot="content">
        <template v-if="dialogSchedule">
          <v-layout row wrap>
            <v-flex md6 pr-2>
              <v-select
                v-model="formSchedule.channel"
                :items="channelsFormatted"
                item-value="id"
                item-text="text"
                v-validate="'required'"
                data-vv-name="channel"
                data-vv-as="canal"
                :error-messages="errors.collect('channel')"
                label="Canal"
                color="black">
              </v-select>
            </v-flex>
            <v-flex md6 pl-2>
              <v-select
                v-model="formSchedule.status"
                :items="statusesForm"
                v-validate="'required'"
                item-text="status"
                item-value="value"
                :disabled="statusesForm.length === 0"
                :data-vv-name="'Estado'"
                :data-vv-as="'Estado'"
                :error-messages="errors.collect('status')"
                label="Estado"
                color="black">
              </v-select>
            </v-flex>
          </v-layout>
          <v-layout row wrap>
            <v-flex :class="{'md4 pr-2':formSchedule.channel !== 5, 'md12':formSchedule.channel === 5}">
              <v-select
                v-model="formSchedule.to"
                :items="customer[`customer_${formSchedule.channel === 1 || formSchedule.channel === 8  ? 'email' : 'phone'}s`]"
                v-validate="'required'"
                :item-text="formSchedule.channel === 1 || formSchedule.channel === 8  ? 'email' : 'phone'"
                :item-value="formSchedule.channel === 1 || formSchedule.channel === 8  ? 'email' : 'phone'"
                data-vv-name="to"
                :data-vv-as="formSchedule.channel === 1 || formSchedule.channel === 8  ? 'email' : 'telefono'"
                :error-messages="errors.collect('to')"
                :label="formSchedule.channel === 1 || formSchedule.channel === 8  ? 'email' : 'Telefono'"
                color="black">
              </v-select>
            </v-flex>
            <v-flex md8 pl-2 v-if="formSchedule.channel !== 5">
              <v-select
                v-model="template"
                :items="templates"
                :disabled="templates.length === 0"
                v-validate="'required'"
                item-text="name"
                return-object
                :data-vv-name="'template_id'"
                :data-vv-as="'Plantilla'"
                :error-messages="errors.collect('template_id')"
                label="Plantilla"
                color="black">
              </v-select>
            </v-flex>
          </v-layout>
          <template v-if="formSchedule.status === 8">
            <v-layout row wrap>
              <v-flex md12>
                <v-menu
                  ref="from"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  :return-value.sync="formSchedule.date"
                  transition="scale-transition"
                  min-width="290px"
                  lazy
                  offset-y
                  full-width>
                    <v-text-field
                      slot="activator"
                      v-model="dateFormatted"
                      append-icon="event"
                      label="Fecha de compromiso"
                      readonly
                      color="black">
                    </v-text-field>
                    <v-date-picker
                      v-model="formSchedule.date"
                      @input="$refs.from.save(formSchedule.date)"
                      locale="es"
                      color="k-orange-linear">
                    </v-date-picker>
                </v-menu>
              </v-flex>
            </v-layout>
          </template>
          <v-layout row wrap>
            <v-flex md12>
              <v-text-field
                color="black"
                label="Descripción"
                v-model="formSchedule.descrip">
              </v-text-field>
            </v-flex>
          </v-layout>
          <template v-if="(formSchedule.channel != 5 && formSchedule.channel != 4) && template.id">
            <v-layout row wrap>
              <v-flex md12 class="my-2 f1-3em grey--text">
                Texto de plantilla
              </v-flex>
              <v-flex md12>
                <div v-html="formatedText(this.template[formScheduleChannelField])"></div>
              </v-flex>
            </v-layout>
          </template>
        </template>
      </template>
    </save-dialog>
  </v-card>
</template>
<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar';
import moment from 'moment';
import NotificationInfo from '@/components/customer/NotificationInfo';
import saveDialogMixin from '@/mixins/saveDialog';
import SkeletonAvatar from '@/components/global/skeletons/Avatar';
import channelsMixin from '@/mixins/channels';
import TableSkeleton from '@/components/global/skeletons/TableSkeleton';
import SkeletonLine from '@/components/global/skeletons/Line';
import SkeletonBox from '@/components/global/skeletons/SkeletonBox';
import saveDialog from '@/components/global/SaveDialog';
import Paginator from '@/components/global/Paginator';
import EventBus from '@/event-bus';
import { mapGetters } from 'vuex';

export default {
  mixins: [
    saveDialogMixin,
    channelsMixin,
  ],
  components: {
    VuePerfectScrollbar,
    NotificationInfo,
    SkeletonAvatar,
    TableSkeleton,
    SkeletonLine,
    SkeletonBox,
    saveDialog,
    Paginator,
  },
  mounted() {
    EventBus.$on('update', () => {
      this.closeModal(true);
    });
    this.fetchNotifications();
  },
  destroy() {
    EventBus.$off('update');
  },
  props: {
    customer: {
      type: Object,
      default: () => {},
    },
    tab: {
      type: String,
      default: 'tab-3',
    },
    fromChatCenter: {
      type: Boolean,
      default: false,
    },
  },
  filters: {
    formatDate(date) {
      return moment(date).format('DD/MM/YYYY h:mm');
    },
  },
  data() {
    return {
      limit: 10,
      page: 1,
      showName: 'gestión',
      data: {},
      // dates: [],
      headers: [
        {
          text: 'Texto 1',
          value: 'local_schedule_date',
        },
        {
          text: 'Texto 2',
          value: 'to',
        },
        {
          text: 'Texto 3',
          value: 'status',
        },
        {
          text: 'Texto 4',
          value: '',
        },
      ],
      steps: [
        'processed_at',
        'sent_carrier_at',
        'sent_at',
        'delivered_at',
        'read_at',
        'click_at',
        'payment_promise',
      ],
      sorting: {
        sortBy: 'created_at',
        descending: true,
      },
      route: 'notification_schedules',
      template: {},
      templates: [],
      isSearching: false,
      cancelToken: this.axios.CancelToken.source(),
      statusesForm: [],
      dialogSchedule: false,
      notificationSchedule: {},
      formSchedule: {
        customer_id: this.customer.id,
        status: '',
        to: '',
        date: moment().format('YYYY-MM-DD'),
        template_id: '',
        channel: 1,
        descrip: '',
      },
    };
  },
  computed: {
    ...mapGetters({
      channels: 'channels',
    }),
    dates() {
      const ns = this.notificationSchedule;
      const dates = [];
      if (Object.keys(ns).length) {
        this.steps.forEach((item) => {
          if (ns[item] !== null) {
            dates.push({
              [item]: ns[item],
            });
          }
        });
      }
      return dates;
    },
    channelsFormatted() {
      if (this.channels.length) {
        return this.channels.filter(x => !x.channel.includes('in_')).map((item) => {
          // eslint-disable-next-line
          item.text = this.showNameChannel(item.id, 'upperAll');
          return item;
        });
      }
      return [];
    },
    formScheduleChannelField() {
      if (this.formSchedule.channel === 1 || this.formSchedule.channel === 8) {
        return 'text';
      } else if (this.formSchedule.channel === 2) {
        return 'sms';
      } else if (this.formSchedule.channel === 3) {
        return 'ivr';
      }
      return 'text';
    },
    dateFormatted() {
      return moment(this.formSchedule.date, 'YYYY-MM-DD').format('DD/MM/YYYY');
    },
  },
  methods: {
    expandRow(props) {
      /* eslint-disable */
      props.expanded = !props.expanded;
      if (props.expanded) {
        this.notificationSchedule = this.data.data[props.index];
      }
    },
    cancelRequest() {
      this.cancelToken.cancel('');
      this.cancelToken = this.axios.CancelToken.source();
    },
    fetchNotifications() {
      this.data = {};
      this.cancelRequest();
      const obj = {};
      if (this.isSearching) {
        obj.cancelToken = this.cancelToken.token;
      }
      this.isSearching = true;
      let url = `customers/${this.customer.id}/notification_schedules?page=${this.page}`
      if( this.fromChatCenter ){
        url = `customers/${this.customer.id}/notification_schedules/chat_center?page=${this.page}`
      }
      this.axios.get(url, obj).then(({ data }) => {
        this.data = data;
        this.isSearching = false;
      }).catch(() => {
        this.isSearching = false;
      });
    },
    getTemplates(channel) {
      if (channel !== 4 && channel !== 5) {
        this.axios.get(`templates?fields=name,id,text,sms,ivr&paginate=0&notNull=${channel}&status=activo`).then((response) => {
          this.templates = response.data;
          this.template = response.data[0];
        }).catch(() => { });
      } else if (channel === 4) {
        this.axios.get('bot_templates?fields=name,id,text,sms,ivr&paginate=0&status=activo').then((response) => {
          this.templates = response.data;
          this.template = response.data[0];
        }).catch(() => { });
      }
    },
    getStatus() {
      this.axios.get(`notification_schedules/status?channel=${this.formSchedule.channel}&type=1&except=1,2,3,4,14,9,11,12,5,27,29,28`).then((res) => {
        this.statusesForm = res.data;
      });
    },
    formatedText(text) {
      if (text && text !== '') {
        let replace, variableText;
        Object.keys(this.customer).forEach((key, i) => {
          variableText = `@${key === 'account' ? 'cuenta' : key === 'first_name' ? 'nombre' : key === 'last_name' ? 'apellido' : key === 'c_to' ? 'email' : key === 'agency' ? 'agencia' : key === 'due_date' ? 'fecha_de_vencimiento' : key === 'invoiced_balance' ? 'monto' : key}`;
          if (i === 0) {
            replace = text.replace(variableText, `<span class="highlight-campaign-template">${this.customer[key]}</span>`);
          } else {
            replace = replace.replace(variableText, `<span class="highlight-campaign-template">${this.customer[key]}</span>`);
          }
        });
        return replace;
      }
    },
    closeModal(saved = false) {
      if (saved) {
        this.data = {};
        this.fetchNotifications();
      }
      this.dialogSchedule = false;
      this.formSchedule = {
        customer_id: this.customer.id,
        status: '',
        to: '',
        date: moment().format('YYYY-MM-DD'),
        template_id: '',
        channel: 1,
        descrip: '',
      };
    },
  },
  watch: {
    page() {
      this.fetchNotifications();
    },
    'formSchedule.channel'(val) { // eslint-disable-line
      if(this.dialogSchedule) {
        this.getStatus();
        this.getTemplates(val);
      }
    },
    dialogSchedule(val) {
      if (val) {
        this.getStatus();
        this.getTemplates(val);
      }
    },
    template(val) {
      this.formSchedule.template_id = val.id;
    },
    tab(value) {
      if (value === 'tab-3') {
        this.fetchNotifications();
      }
    },
  },
};
</script>
<style scoped>
  .hovereable:hover {
    background: rgba(0,0,0,0.12);
    cursor:pointer;
  }
  .customer-movements {
    height: 392px;
  }
  .customer-movements >>> .datatable.table > thead {
    display: none;
  }
  .customer-movements >>> .datatable.table td {
    padding-top: 6px !important;
    padding-bottom: 6px !important; 
  }
  .customer-movements >>> .datatable.table td {
    padding-right: 0px !important;
  }
  .customer-movements >>> table.table tbody tr:first-child {
    border-top: 1px solid rgba(0,0,0,.12) !important;
  }
  .customer-movements >>> table.table tbody tr:not(:last-child):not(.datatable__expand-row) {
    border-bottom: 1px solid rgba(0,0,0,.12) !important;
  }
  .customer-movements >>> table.table tbody tr.datatable__expand-row .datatable__expand-col {
    padding-left: 0 !important;
  }
  .customer-movements >>> table.table tbody tr.datatable__expand-row .datatable__expand-col--expanded .datatable__expand-content {
    border-bottom: 1px solid rgba(0,0,0,.12) !important;
  }
  .small {
    font-size: 12px !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/customer/CustomerMovements.vue